import styles from './styles.module.scss';
export const EmptyTable = ({ emptyText }: { emptyText: string }) => {
  return <div className={styles.emptyTableWrapper}>{emptyText}</div>;
};
